import type { FC, ReactElement } from 'react';
import type { PermissionScope } from 'utils/hooks/usePermissionScope';
import { useHasPermission } from 'utils/permissions/useHasPermission';

interface Props {
  children: ReactElement;
  requiredScope: PermissionScope[];
}

export const Permissions: FC<Props> = (props) => {
  const hasPermission = useHasPermission();

  return hasPermission(props.requiredScope) ? props.children : null;
};
